export default __webpack_public_path__ + "static/media/icon_card_date.2ff19288.svg";